import { Box } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import GoBack from 'components/GoBack'
import FitContentPaper from 'components/Paper/FitContentPaper'
import { FormikHelpers } from 'formik'
import useRestricter from 'hooks/useRestricter'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { RouteConfigComponentProps } from 'react-router-config'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { offeringListThunk, selectCurrentTempleOfferings } from 'store/reducers/temple/offeringSlice'
import {
    selectStaffAssignmentById,
    selectStaffAssignmentStatus,
    staffAssignmentRetrieveThunk,
    staffAssignmentUpdateThunk,
} from 'store/reducers/temple/staffAssignmentSlice'
import { selectCurrentTempleStaffProfiles, staffProfileListThunk } from 'store/reducers/temple/staffProfileSlice'
import { StaffPujaAssignmentPayloadType } from 'types/api/temple'
import { getFieldErrors } from 'utils/api'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import FormStaffAssignment from './FormStaffAssignment'

interface RouteParams {
    id: string
}

const EditStaffAssignment: React.FC<RouteConfigComponentProps<RouteParams>> = props => {
    const { id } = props.match.params
    const dispatch = useAppDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const api = useAppSelector(selectStaffAssignmentStatus)
    const assignment = useAppSelector(state => selectStaffAssignmentById(state, id))
    const profiles = useAppSelector(selectCurrentTempleStaffProfiles)
    const offerings = useAppSelector(selectCurrentTempleOfferings)
    const hasEditPermission = useRestricter(PERMISSIONS.CHANGE, RESTRICTED_PATHS.STAFF_ASSIGNMENTS)

    useEffect(() => {
        dispatch(staffProfileListThunk({}))
        dispatch(offeringListThunk({}))
        dispatch(staffAssignmentRetrieveThunk({ id }))
    }, [dispatch, id])

    const handleSubmit = (data: StaffPujaAssignmentPayloadType, actions: FormikHelpers<StaffPujaAssignmentPayloadType>) => {
        dispatch(staffAssignmentUpdateThunk({ id, data }))
            .then(unwrapResult)
            .then(response => enqueueSnackbar(`Assignment updated for ${response.staffName}`, { variant: 'success' }))
            .catch(err => {
                Object.entries(getFieldErrors(data, err)).forEach(([key, value]) => actions.setFieldError(key, value))
            })
            .finally(() => actions.setSubmitting(false))
    }

    if (!hasEditPermission) return null

    return (
        <GoBack {...props}>
            <FitContentPaper>
                <Box component='h4' mb={4}>Edit Staff Assignment</Box>
                <FormStaffAssignment
                    initialValues={assignment}
                    priests={profiles.filter(profile => profile.roleType === 'priest' && profile.isActive)}
                    offerings={offerings}
                    buttonLabel='Update'
                    api={api}
                    onSubmit={handleSubmit}
                />
            </FitContentPaper>
        </GoBack>
    )
}

export default EditStaffAssignment
